/**
 * The organisation switcher's page, registered by existing rather than by
 * being imported: `../routes/index.ts` discovers this file by its literal
 * glob, so the extension is load-bearing and the element is built with
 * `createElement`.
 *
 * No `requires`: the page lists what `/control/me` returned and gates nothing
 * itself (platform design §17.2), so a caller holding no capability anywhere
 * still reaches the one screen that shows them where they can act. There is no
 * nav entry either; the popover's "Ver todas as organizações" is the way in.
 */
import { createElement } from 'react';

import type { RouteBundle } from '../routes/contract';
import { SwitcherPage } from './switcher/SwitcherPage';
import { SWITCH_ALL_PATH } from './switcher/paths';

export const bundle: RouteBundle = {
  routes: [{ path: SWITCH_ALL_PATH, element: createElement(SwitcherPage), kind: 'data' }],
  nav: [],
};
